import { Box, CircularProgress } from "@mui/material";

const LoadingBox = () => {
  return (
    <Box
      sx={{
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <CircularProgress color="inherit" />
    </Box>
  );
};

export default LoadingBox;
